import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const TutorialsPage = () => {
  return (
    <List
      category={'tutorials'}
      heading={'Tutorials'}
      cardHeader={categories.tutorials.cardHeader}
      icons={categories.tutorials.icons}
      dotColor={categories.tutorials.dotColor}
    />
  );
};

export default TutorialsPage;
